export enum LessonsRoutesEnum {
  MOVE = 'move',
}
